<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bVVcNt/tc-custom/9781429930086.jpg?1722339024827" alt="This image is the cover for the book Security"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Security
      </h1>
      <p class="bookDescription body article font2">
        <p>There isn't much crime in Stoneleigh, Massachusetts. It's a college town, a mountain getaway for the quietly rich,<br/>where the average burglar alarm is set off by foraging wildlife. So when Edward Inman, the owner of Stoneleigh Sentinel, gets a latenight false alarm from the home of Doyle Cutler, one of his wealthiest clients, Edward thinks nothing of it—not until a local student, Mary Steckl, claims that she was sexually assaulted at Cutler's house.<br/><br/>Edward soon finds himself drawn to Mary's story, even though the rest of the town doubts her, including his wife, a rising politician who has made security the platform of her mayoral campaign. While homework from a creative writing class is leaked as evidence of a dark secret between Mary and her father, Edward's investigations lead him to his old girlfriend, Kathryn Williams, whose teenage son may hold the key to the truth about that night.<br/><br/>From the author of <i>Human Capital</i>, <i>Security</i> is a timely, wry, and riveting story of adults and children, secret lives and civic<br/>culture, suspicion and sexual hysteria. It confirms Stephen Amidon as a master of the art and one of the foremost chroniclers of American life today.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephen Amidon
      </h2>
      
      <p class="authorDescription body article"><P><B>STEPHEN AMIDON</B>'s previous books include <I>Human Capital</I>, <I>The New City</I>, and <I>Subdivision</I>. He lives in western Massachusetts.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?96194394